import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import "./style/ValidatePage.css"; // Importar los estilos
import { UserService } from "../../services/User.service";

const ValidatePage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [message, setMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const validateToken = async () => {
      try {
        setLoading(true);
        const response = await UserService.verifyUser(token as string);
        if (response.status === 200) {
          setMessage(response.message);
          setError(null); // Asegurarse de que no haya error
        } else {
          setError(response.message);
          setMessage(null); // Asegurarse de que no haya mensaje exitoso
        }
      } catch (error) {
        setError(error instanceof Error ? error.message : "Hubo un error inesperado");
        setMessage(null); // Asegurarse de que no haya mensaje exitoso
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      validateToken();
    }
  }, [token]);

  return (
    <div className="validate-container">
      <h1 className="validate-title">Validación de Usuario</h1>
      {loading && <p className="validate-loading">Validando...</p>}
      {error && <p className="validate-error">{error}</p>}
      {message && (
        <div>
          <p className="validate-success">{message}</p>
          <Link to="/login" className="validate-link">
            Volver a Inicio de Sesión
          </Link>
        </div>
      )}
    </div>
  );
};

export default ValidatePage;
